<template>
  <div class="channel-wrap">
    <el-select v-model="userId" filterable @change="getList" style="margin-bottom: 12px; width: 300px" placeholder="请选择用户">
      <el-option v-for="item in userOptions" :key="item.clientId" :label="item.youtubeUserName" :value="item.clientId">
        {{ item.youtubeUserName }}（id：{{ item.clientId }}）
      </el-option>
    </el-select>
    <el-button @click="handerRefresh" style="margin-left: 20px">同步</el-button>
    <div class="table">
      <el-table :border="false" v-loading="loading" :data="tableData" style="width: 100%" height="100%">
        <el-table-column prop="name" label="频道"></el-table-column>
        <el-table-column prop="id" label="频道ID"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getChannelList, getYoutubePermUserList, refreshYoutubeChannel } from "@/api/property.js";
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      userOptions: [],
      userId: "",
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.getOptions();
  },

  methods: {
    getOptions() {
      getYoutubePermUserList().then((res) => {
        this.userOptions = res.data;
        if (res.data?.length > 0) {
          this.userId = res.data[0].clientId;
          this.getList();
        } else {
          this.tableData = [];
        }
      });
    },
    handerRefresh() {
      refreshYoutubeChannel().then((res) => {
        if (res.code === "0000") {
          this.$message.success("同步成功");
          this.getOptions();
        }
      });
    },
    getList() {
      this.loading = true;
      getChannelList({
        userId: this.userId,
        userName: this.userOptions.find((item) => item.clientId === this.userId).youtubeUserName,
      })
        .then((res) => {
          this.tableData = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deleteChannel() {
      this.$confirm("确定删除该频道?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.channel-wrap {
  height: calc(~"100vh - 180px");
  .table {
    height: calc(100% - 80px);
  }
  .dialog-footer {
    position: relative;
    .btn {
      padding-left: 38px;
    }
    .icon {
      font-size: 26px;
      position: absolute;
      top: -4px;
      left: 10px;
    }
  }
}
</style>
